if (!customElements.get("custom-swiper")) {
  customElements.define(
    "custom-swiper",

    class CustomSwiper extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const optionsScript = this.querySelector("[id^=SwiperOptions]");
        if (!optionsScript) return;

        try {
          this.swiperOptions = JSON.parse(optionsScript.innerHTML);
        } catch (e) {
          console.error("CustomSwiper: Failed to parse options", e);
          return;
        }

        this.init();
      }

      init() {
        if (this.swiper) return;

        const thumbsOptions = this.swiperOptions.thumbs;
        if (thumbsOptions && typeof thumbsOptions.swiper === "string") {
          const thumbsElement = document.querySelector(thumbsOptions.swiper);
          if (thumbsElement && !thumbsElement.swiper) {
            setTimeout(() => this.init(), 100);
            return;
          }

          if (thumbsElement && thumbsElement.swiper) {
            this.swiperOptions.thumbs.swiper = thumbsElement.swiper;
          }
        }

        this.swiper = new Swiper(
          this.querySelector(".swiper"),
          this.swiperOptions
        );
      }
    }
  );
}
